const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3588.9924,
    y1: 4065.3438,
    x2: 1108.5569,
    y2: 984.7986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2906.609,2850.488c-56.975,59.98-110.883,98.661-153.476,129.221 c-500.665,359.232-1093.083,254.518-1218.99,228.946c-185.923-37.762-545.309-110.755-805.138-416.309 c-393.1-462.278-331.889-1190.583-26.974-1671.348c55.774-87.94,350.387-576.028,949.187-654.302 c362.387-47.371,784.814,48.17,1090.724,304.462C3384.075,1309.138,3338.362,2395.952,2906.609,2850.488z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -803.9916 1708.781)",
    style: {
      fill: "#BDD0FB"
    },
    cx: 1660.685,
    cy: 1824.894,
    rx: 1074.288,
    ry: 1074.288
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034064292087926640360000004489801188548880018_",
    gradientUnits: "userSpaceOnUse",
    x1: 2459.4434,
    y1: 764.4141,
    x2: 395.0129,
    y2: 3505.2795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000034064292087926640360000004489801188548880018_)"
    },
    cx: 1660.686,
    cy: 1824.894,
    r: 916.864
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1660.684,2787.682c-530.879,0-962.784-431.901-962.784-962.788 s431.905-962.788,962.784-962.788s962.784,431.901,962.784,962.788S2191.563,2787.682,1660.684,2787.682z M1660.684,908.03 c-505.559,0-916.859,411.3-916.859,916.863c0,505.564,411.3,916.863,916.859,916.863c505.56,0,916.859-411.299,916.859-916.863 C2577.543,1319.33,2166.244,908.03,1660.684,908.03z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145045335878290404100000006483488866715852953_",
    gradientUnits: "userSpaceOnUse",
    x1: 2459.4429,
    y1: 764.4142,
    x2: 395.0159,
    y2: 3505.2749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000145045335878290404100000006483488866715852953_)"
    },
    cx: 1660.685,
    cy: 1824.894,
    r: 558.964
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1660.684,2429.784c-333.534,0-604.885-271.355-604.885-604.89s271.351-604.882,604.885-604.882 c333.535,0,604.886,271.347,604.886,604.882S1994.219,2429.784,1660.684,2429.784z M1660.684,1311.855 c-282.892,0-513.042,230.147-513.042,513.039s230.15,513.047,513.042,513.047c282.893,0,513.043-230.155,513.043-513.047 S1943.577,1311.855,1660.684,1311.855z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167390371192408270590000007613060532918668202_",
    gradientUnits: "userSpaceOnUse",
    x1: 1847.8938,
    y1: 349.2417,
    x2: 1732.9768,
    y2: 1255.0629
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000167390371192408270590000007613060532918668202_)"
    },
    cx: 1660.685,
    cy: 1824.894,
    r: 216.559
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1660.684,2087.377c-144.732,0-262.48-117.747-262.48-262.484s117.748-262.484,262.48-262.484 c144.732,0,262.484,117.747,262.484,262.484S1805.416,2087.377,1660.684,2087.377z M1660.684,1654.253 c-94.089,0-170.636,76.547-170.636,170.641c0,94.094,76.547,170.641,170.636,170.641c94.09,0,170.641-76.547,170.641-170.641 C1831.324,1730.8,1754.774,1654.253,1660.684,1654.253z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037675127564558895180000000498400605238673831_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.3733,
    y1: 3877.0906,
    x2: -70.6925,
    y2: 4925.479,
    gradientTransform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -1192.2574 4633.1733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000037675127564558895180000000498400605238673831_)"
    },
    points: "2685.745,802.602  2708.555,825.412 1844.808,1689.158 1821.998,1666.349  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157273033472889704720000014444471464055916941_",
    gradientUnits: "userSpaceOnUse",
    x1: -32.6726,
    y1: 4097.4595,
    x2: -111.5292,
    y2: 4943.3818,
    gradientTransform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -1192.2574 4633.1733)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157273033472889704720000014444471464055916941_)"
    },
    d: "M1838.154,1611.312 c13.086-13.086,74.777,48.605,61.691,61.691l-228.811,179.881c-8.454,6.645-19.407-4.308-12.761-12.762L1838.154,1611.312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2708.062,825.905l116.201,11.549l-159.521,159.522 c-52.266,52.265-125.219,78.332-198.772,71.021l0,0L2708.062,825.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2685.251,803.096l-11.549-116.201l-159.521,159.521 c-52.266,52.266-78.332,125.219-71.022,198.772l0,0L2685.251,803.096z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1090.588,642.251c-3.247,3.247-8.512,3.244-11.756-0.003 c-6.306-6.308-12.978-12.437-19.834-18.215c-3.469-2.924-3.945-8.079-1.101-11.588c0.034-0.042,0.067-0.083,0.102-0.126 c2.958-3.51,8.203-3.956,11.714-0.997c7.216,6.083,14.242,12.534,20.879,19.175c3.036,3.036,3.229,7.839,0.583,11.102 C1090.992,641.825,1090.798,642.044,1090.588,642.251z M1023.698,598.197c-7.576-4.788-15.428-9.296-23.346-13.405 c-4.072-2.113-5.664-7.13-3.551-11.206c2.136-4.083,7.133-5.664,11.208-3.549c8.33,4.321,16.596,9.067,24.569,14.103 c3.88,2.452,5.038,7.588,2.586,11.469c-0.178,0.282-0.371,0.55-0.575,0.802 C1031.972,599.638,1027.296,600.471,1023.698,598.197z M960.235,567.407c-8.428-2.973-17.088-5.615-25.744-7.854 c-4.444-1.149-7.115-5.685-5.966-10.129c1.153-4.439,5.684-7.113,10.13-5.966c9.115,2.358,18.237,5.141,27.111,8.272 c4.329,1.527,6.6,6.275,5.075,10.605c-0.326,0.923-0.798,1.752-1.381,2.471C967.308,567.458,963.641,568.609,960.235,567.407z  M891.481,551.584c-8.891-1.016-17.928-1.655-26.863-1.906c-4.589-0.13-8.206-3.955-8.077-8.542 c0.133-4.588,3.957-8.201,8.542-8.077c9.408,0.265,18.923,0.94,28.279,2.005c4.56,0.521,7.837,4.64,7.317,9.201 c-0.186,1.632-0.833,3.1-1.796,4.288C897.154,550.685,894.409,551.916,891.481,551.584z M820.914,551.473 c-8.872,0.982-17.83,2.358-26.619,4.094c-4.506,0.887-8.876-2.044-9.765-6.548c-0.89-4.507,2.044-8.877,6.548-9.762 c9.246-1.825,18.672-3.273,28.008-4.306c4.562-0.506,8.671,2.783,9.175,7.347c0.255,2.299-0.454,4.483-1.804,6.149 C825.128,550.086,823.178,551.222,820.914,551.473z M752.083,566.978c-8.448,2.924-16.874,6.247-25.047,9.879 c-4.195,1.864-9.109-0.026-10.971-4.219c-1.865-4.196,0.022-9.107,4.219-10.973c8.6-3.823,17.472-7.32,26.362-10.397 c4.339-1.5,9.071,0.799,10.574,5.137c0.976,2.818,0.346,5.802-1.404,7.96C754.872,565.528,753.605,566.452,752.083,566.978z  M540.056,791.31c-4.442-1.156-7.107-5.696-5.95-10.139c2.371-9.101,5.172-18.222,8.325-27.107 c1.536-4.327,6.288-6.59,10.614-5.053c4.325,1.533,6.587,6.286,5.053,10.611c-2.994,8.436-5.652,17.097-7.903,25.74 c-0.309,1.186-0.857,2.243-1.582,3.138C546.623,790.953,543.313,792.159,540.056,791.31z M688.439,597.336 c-7.582,4.727-15.051,9.84-22.199,15.202c-3.675,2.753-8.885,2.009-11.639-1.664c-2.756-3.675-1.994-8.867,1.665-11.638 c7.528-5.645,15.394-11.03,23.379-16.008c3.896-2.428,9.022-1.24,11.452,2.657c1.926,3.089,1.576,6.955-0.595,9.633 C689.936,596.217,689.244,596.833,688.439,597.336z M564.351,723.058c-4.07-2.121-5.65-7.143-3.528-11.214 c4.348-8.337,9.114-16.598,14.16-24.554c2.445-3.891,7.596-5.023,11.473-2.566c3.875,2.459,5.024,7.595,2.565,11.473 c-4.797,7.56-9.326,15.41-13.456,23.335c-0.263,0.506-0.574,0.971-0.919,1.397 C572.208,723.936,567.915,724.917,564.351,723.058z M633.187,641.149c-6.329,6.301-12.47,12.957-18.251,19.789 c-2.965,3.507-8.209,3.943-11.715,0.977c-3.458-2.927-3.929-8.074-1.089-11.577c0.037-0.045,0.075-0.092,0.114-0.135 c6.084-7.194,12.548-14.203,19.208-20.835c3.256-3.237,8.518-3.226,11.758,0.027c3.025,3.038,3.214,7.833,0.572,11.091 C633.598,640.713,633.398,640.935,633.187,641.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M539.073,846.083c1.031-1.271,1.7-2.859,1.829-4.616c0.314-4.275,0.725-8.612,1.215-12.898 c0.524-4.56-2.75-8.683-7.309-9.205c-4.561-0.525-8.689,2.747-9.205,7.311c-0.518,4.506-0.949,9.069-1.281,13.567 c-0.338,4.577,3.101,8.565,7.677,8.901C534.821,849.353,537.417,848.126,539.073,846.083z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M620.605,1086.035c2.527-3.116,2.491-7.691-0.272-10.775c-2.86-3.19-5.702-6.496-8.443-9.822 c-2.921-3.543-8.16-4.047-11.702-1.127c-3.557,2.933-4.046,8.161-1.127,11.702c2.888,3.501,5.88,6.983,8.89,10.343 c3.064,3.419,8.319,3.706,11.739,0.643C620.025,1086.698,620.33,1086.374,620.605,1086.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1102.529,1086.77c-3.062,3.42-8.318,3.711-11.74,0.646c-3.419-3.063-3.705-8.309-0.646-11.737 c5.831-6.511,11.473-13.372,16.841-20.468c2.744-3.653,7.984-4.382,11.645-1.613c3.661,2.77,4.383,7.983,1.615,11.645 c-2.326,3.074-4.693,6.098-7.102,9.069C1109.707,1078.551,1106.136,1082.743,1102.529,1086.77z M1133.743,1030.519 c-4-2.248-5.422-7.316-3.172-11.317c4.316-7.685,8.356-15.632,12.004-23.627c1.891-4.177,6.835-6.018,11.013-4.113 c4.174,1.905,6.016,6.836,4.11,11.011c-3.84,8.417-8.092,16.786-12.636,24.87c-0.236,0.419-0.503,0.811-0.795,1.172 C1141.763,1031.604,1137.328,1032.533,1133.743,1030.519z M1070.072,1118.366c-7.053,5.982-14.459,11.745-22.014,17.124 c-3.74,2.663-8.93,1.791-11.595-1.95c-2.662-3.739-1.786-8.924,1.95-11.593c7.176-5.108,14.208-10.579,20.904-16.26 c3.502-2.969,8.747-2.539,11.718,0.963c2.626,3.097,2.59,7.56,0.122,10.604 C1070.837,1117.65,1070.475,1118.024,1070.072,1118.366z M1163.289,965.639c-4.398-1.314-6.899-5.947-5.582-10.345 c2.521-8.431,4.711-17.071,6.51-25.678c0.938-4.498,5.341-7.376,9.837-6.435c4.493,0.939,7.374,5.341,6.435,9.834 c-1.895,9.065-4.201,18.164-6.855,27.041c-0.322,1.072-0.838,2.034-1.502,2.853 C1170.074,965.448,1166.614,966.633,1163.289,965.639z M1009.471,1159.15c-8.191,4.281-16.68,8.271-25.233,11.86 c-4.233,1.777-9.102-0.213-10.88-4.445c-1.779-4.235,0.214-9.106,4.447-10.883c8.124-3.41,16.187-7.199,23.965-11.266 c4.069-2.127,9.092-0.552,11.218,3.517c1.584,3.032,1.114,6.592-0.911,9.089 C1011.384,1157.877,1010.507,1158.609,1009.471,1159.15z M941.394,1185.655c-8.95,2.393-18.106,4.436-27.212,6.073 c-4.52,0.81-8.84-2.193-9.653-6.712c-0.812-4.525,2.192-8.844,6.712-9.65c8.652-1.556,17.353-3.497,25.859-5.77 c4.435-1.186,8.991,1.448,10.178,5.884c0.713,2.673,0.04,5.389-1.578,7.386 C944.632,1184.182,943.155,1185.184,941.394,1185.655z M869.156,1196.694c-9.264,0.387-18.648,0.387-27.887,0.002 c-4.589-0.192-8.149-4.065-7.959-8.652c0.192-4.593,4.067-8.15,8.651-7.958c8.781,0.368,17.694,0.366,26.5-0.002 c4.587-0.192,8.461,3.372,8.652,7.957c0.089,2.108-0.614,4.062-1.845,5.58C873.817,1195.41,871.636,1196.59,869.156,1196.694z  M796.231,1191.713c-9.123-1.647-18.282-3.704-27.222-6.114c-4.432-1.194-7.058-5.756-5.863-10.19 c1.193-4.425,5.758-7.055,10.19-5.861c8.487,2.287,17.183,4.24,25.851,5.804c4.517,0.816,7.518,5.138,6.702,9.655 c-0.258,1.427-0.865,2.701-1.718,3.753C802.323,1191.041,799.323,1192.27,796.231,1191.713z M726.146,1170.818 c-8.515-3.608-16.989-7.63-25.188-11.953c-4.061-2.142-5.619-7.171-3.476-11.231c2.136-4.047,7.167-5.618,11.229-3.476 c7.788,4.108,15.837,7.926,23.925,11.355c4.226,1.79,6.2,6.67,4.409,10.896c-0.312,0.736-0.716,1.405-1.196,1.996 C733.574,1171.21,729.636,1172.297,726.146,1170.818z M662.426,1135.081c-5.546-3.961-11.038-8.143-16.322-12.427 c-1.914-1.552-3.803-3.119-5.674-4.705c-3.5-2.967-4.039-8.226-0.965-11.714c2.966-3.504,8.212-3.936,11.716-0.968 c1.777,1.505,3.575,2.999,5.394,4.473c5.024,4.074,10.242,8.047,15.515,11.814c3.735,2.667,4.6,7.86,1.932,11.594 c-0.101,0.14-0.204,0.278-0.311,0.41C670.964,1136.945,666.02,1137.65,662.426,1135.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1184.874,892.58c1.041-1.284,1.71-2.887,1.833-4.659c0.309-4.49,0.528-9.071,0.652-13.616 c0.126-4.59-3.492-8.412-8.081-8.537c-4.589-0.124-8.412,3.488-8.537,8.081c-0.119,4.318-0.328,8.669-0.62,12.932 c-0.317,4.577,3.14,8.547,7.721,8.862C1180.651,895.835,1183.228,894.61,1184.874,892.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1091.37,785.043c-0.339-1.623-1.668-2.853-3.312-3.062l-46.904-5.989 c-9.309-20.024-21.877-38.708-37.538-55.174l11.612-45.805c0.407-1.607-0.25-3.295-1.636-4.204l-47.431-31.097 c-1.386-0.91-3.197-0.839-4.507,0.175L924.276,668.8c-21.345-7.797-43.491-11.874-65.566-12.426l-24.194-40.626 c-0.848-1.424-2.507-2.153-4.129-1.815l-55.529,11.549c-1.622,0.337-2.853,1.667-3.062,3.312l-5.988,46.904 c-20.025,9.308-38.709,21.876-55.174,37.539l-45.805-11.612c-1.607-0.408-3.295,0.249-4.203,1.635l-31.099,47.432 c-0.909,1.386-0.837,3.196,0.176,4.507l28.913,37.377c-7.798,21.345-11.874,43.491-12.425,65.566l-40.626,24.194 c-1.424,0.848-2.154,2.506-1.815,4.129l11.549,55.529c0.337,1.622,1.668,2.852,3.311,3.062l46.905,5.989 c9.307,20.025,21.876,38.708,37.538,55.174l-11.611,45.805c-0.408,1.607,0.249,3.295,1.635,4.203l47.432,31.098 c1.386,0.909,3.196,0.838,4.507-0.176l37.377-28.913c21.345,7.797,43.491,11.874,65.566,12.426l24.194,40.626 c0.847,1.424,2.505,2.153,4.129,1.816l55.529-11.55c1.622-0.338,2.852-1.667,3.062-3.311l5.988-46.904 c20.025-9.308,38.708-21.876,55.174-37.538l45.805,11.612c1.606,0.406,3.294-0.25,4.203-1.636l31.098-47.432 c0.909-1.386,0.839-3.196-0.176-4.507l-28.912-37.376c7.797-21.345,11.873-43.491,12.425-65.566l40.626-24.194 c1.424-0.848,2.153-2.507,1.816-4.129L1091.37,785.043z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M891.909,905.496c-23.147,21.27-59.282,19.745-80.555-3.403 c-10.305-11.212-15.626-25.767-14.982-40.982c0.641-15.212,7.168-29.268,18.385-39.571 c23.148-21.27,59.282-19.745,80.555,3.403c19.351,21.059,19.835,52.866,2.332,74.453 C895.91,901.537,893.996,903.578,891.909,905.496z M809.661,861.674c-0.493,11.666,3.586,22.824,11.488,31.423 c16.308,17.745,44.016,18.917,61.762,2.608c17.757-16.308,18.917-44.016,2.608-61.764 c-16.308-17.745-44.016-18.917-61.762-2.608c-1.609,1.479-3.089,3.057-4.441,4.724 C813.446,843.297,810.062,852.193,809.661,861.674z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M960.872,952.161c3.006-3.707,5.843-7.588,8.496-11.633l0,0c0.836-1.273,1.65-2.561,2.444-3.86 c3.914-6.41,7.311-13.121,10.141-20.029c0.039-0.094,0.077-0.188,0.116-0.282c0.108-0.267,0.216-0.535,0.322-0.805 c0.21-0.522,0.413-1.046,0.616-1.57c0.532-1.378,0.084-2.893-1.004-3.778c-0.265-0.215-0.568-0.392-0.903-0.521 c-1.713-0.661-3.634,0.197-4.297,1.907c-3.399,8.817-7.772,17.325-12.997,25.29c-25.938,39.576-69.46,60.835-113.593,60.268 c-24.548-0.312-49.285-7.381-71.293-21.812c-3.86-2.529-7.564-5.236-11.099-8.104c-23.797-19.298-40.097-45.972-46.419-76.372 c-7.264-34.92-0.494-70.58,19.062-100.407c40.395-61.598,123.314-78.826,184.886-38.456c3.797,2.489,7.453,5.161,10.955,8.003 c15.179,12.311,27.495,27.807,36.011,45.418c0.221,0.455,0.529,0.837,0.899,1.134c0.969,0.785,2.344,0.991,3.542,0.411 c1.652-0.805,2.35-2.785,1.545-4.442c-8.94-18.489-21.87-34.76-37.806-47.684c-3.676-2.983-7.514-5.787-11.498-8.401 c-64.645-42.385-151.726-24.253-194.096,40.369c-20.531,31.314-27.637,68.748-20.011,105.408 c6.636,31.916,23.749,59.917,48.73,80.178c3.713,3.01,7.6,5.851,11.65,8.507c31.317,20.531,68.751,27.639,105.41,20.014 C912.605,994.272,940.611,977.151,960.872,952.161z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1439.975,559.22c1.399-1.725,1.562-4.227,0.235-6.148c-2.475-3.587-5.092-7.149-7.78-10.585 c-1.747-2.232-4.971-2.626-7.207-0.88c-2.244,1.741-2.626,4.974-0.88,7.207c2.561,3.274,5.056,6.668,7.419,10.091 c1.607,2.332,4.805,2.918,7.141,1.31C1439.316,559.929,1439.673,559.592,1439.975,559.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1414.305,529.303c-2.002,2.008-5.25,2.017-7.261,0.015 c-5.074-5.046-10.465-9.892-16.023-14.398c-1.172-0.95-2.36-1.89-3.56-2.822c-2.236-1.739-2.643-4.964-0.904-7.204 c1.729-2.052,4.964-2.643,7.207-0.905c1.255,0.976,2.497,1.96,3.724,2.954c5.826,4.724,11.479,9.804,16.798,15.098 c1.883,1.872,2.009,4.846,0.37,6.867C1414.547,529.044,1414.429,529.174,1414.305,529.303z M1365.933,497.39 c-7.449-4.449-15.24-8.477-23.156-11.968c-2.595-1.146-3.769-4.172-2.625-6.769c1.142-2.579,4.174-3.771,6.769-2.625 c8.297,3.658,16.466,7.88,24.276,12.547c2.435,1.454,3.229,4.607,1.777,7.043c-0.128,0.213-0.272,0.415-0.425,0.604 C1370.966,498.173,1368.151,498.715,1365.933,497.39z M1318.309,476.408c-8.299-2.485-16.841-4.473-25.395-5.912 c-2.794-0.471-4.68-3.12-4.209-5.914c0.474-2.805,3.114-4.685,5.914-4.212c8.969,1.508,17.931,3.597,26.633,6.199 c2.716,0.814,4.262,3.675,3.448,6.391c-0.201,0.661-0.52,1.254-0.93,1.76C1322.499,476.288,1320.362,477.021,1318.309,476.408z  M1266.985,467.768c-8.669-0.374-17.442-0.213-26.061,0.483c-2.83,0.226-5.304-1.88-5.53-4.706 c-0.225-2.819,1.877-5.3,4.703-5.53c9.045-0.728,18.238-0.897,27.331-0.505c2.832,0.121,5.031,2.52,4.909,5.353 c-0.053,1.141-0.47,2.18-1.14,3.006C1270.207,467.089,1268.675,467.842,1266.985,467.768z M1215.106,471.921 c-8.495,1.745-16.959,4.032-25.165,6.796c-2.684,0.906-5.597-0.539-6.504-3.227c-0.906-2.687,0.534-5.602,3.227-6.504 c8.598-2.898,17.472-5.294,26.374-7.126c2.778-0.568,5.492,1.219,6.062,3.995c0.322,1.569-0.107,3.118-1.042,4.271 C1217.337,471.015,1216.315,471.671,1215.106,471.921z M1165.808,488.541c-7.808,3.755-15.452,8.033-22.724,12.719 c-2.381,1.535-5.561,0.848-7.095-1.534c-1.534-2.383-0.851-5.55,1.534-7.099c7.624-4.914,15.646-9.402,23.836-13.341 c2.556-1.226,5.623-0.153,6.85,2.401c0.888,1.85,0.572,3.969-0.639,5.462C1167.107,487.719,1166.516,488.201,1165.808,488.541z  M1122.09,516.701c-6.627,5.539-12.994,11.568-18.922,17.925c-1.936,2.07-5.184,2.183-7.256,0.248 c-2.073-1.932-2.157-5.15-0.253-7.259c6.22-6.659,12.894-12.982,19.844-18.791c2.177-1.817,5.415-1.528,7.234,0.647 c1.599,1.913,1.566,4.652,0.051,6.521C1122.582,516.244,1122.35,516.483,1122.09,516.701z M1065.61,578.75 c-2.482-1.373-3.378-4.495-2.005-6.977c3.8-6.868,8.043-13.646,12.595-20.128c0.687-0.989,1.385-1.963,2.089-2.934 c1.592-2.33,4.879-2.802,7.174-1.126c2.293,1.669,2.796,4.878,1.129,7.173c-0.664,0.907-1.318,1.826-1.974,2.769 c-4.359,6.203-8.406,12.668-12.031,19.217c-0.148,0.27-0.32,0.522-0.506,0.752 C1070.542,579.395,1067.82,579.974,1065.61,578.75z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1427.955,821.094c-5.724,6.877-11.921,13.461-18.411,19.579 c-2.064,1.941-5.313,1.847-7.259-0.218c-1.947-2.066-1.815-5.308,0.218-7.259c6.192-5.83,12.099-12.113,17.561-18.674 c1.813-2.18,5.052-2.474,7.229-0.661c2.161,1.8,2.471,5.001,0.706,7.178C1427.985,821.057,1427.969,821.076,1427.955,821.094z  M1436.788,800.95c-2.379-1.539-3.061-4.719-1.52-7.097c4.632-7.162,8.878-14.676,12.617-22.336 c1.244-2.529,4.318-3.606,6.868-2.357c2.548,1.243,3.602,4.314,2.361,6.864c-3.92,8.027-8.369,15.902-13.226,23.405 c-0.103,0.159-0.21,0.307-0.327,0.451C1441.932,801.89,1439.015,802.39,1436.788,800.95z M1388.874,857.88 c-7.221,5.292-14.826,10.189-22.604,14.552c-2.473,1.387-5.605,0.505-6.99-1.966c-1.39-2.473-0.509-5.589,1.962-6.99 c7.422-4.161,14.674-8.831,21.566-13.877c2.288-1.676,5.5-1.179,7.173,1.104c1.409,1.924,1.283,4.5-0.151,6.268 C1389.559,857.306,1389.24,857.612,1388.874,857.88z M1460.884,754.353c-2.681-0.922-4.105-3.845-3.184-6.525 c2.775-8.064,5.081-16.377,6.851-24.714c0.593-2.769,3.32-4.54,6.086-3.956c2.774,0.591,4.547,3.316,3.957,6.09 c-1.854,8.743-4.272,17.466-7.185,25.922c-0.203,0.584-0.499,1.109-0.867,1.562 C1465.223,754.359,1462.979,755.073,1460.884,754.353z M1342.077,884.122c-8.263,3.393-16.821,6.313-25.438,8.686 c-2.734,0.753-5.561-0.856-6.313-3.589c-0.753-2.734,0.85-5.562,3.589-6.314c8.221-2.258,16.381-5.046,24.26-8.285 c2.622-1.076,5.622,0.175,6.7,2.802c0.739,1.796,0.38,3.774-0.764,5.186C1343.588,883.252,1342.9,883.783,1342.077,884.122z  M1290.343,898.373c-8.852,1.317-17.865,2.107-26.782,2.352c-2.833,0.078-5.192-2.154-5.269-4.989 c-0.08-2.831,2.154-5.196,4.992-5.273c8.503-0.234,17.101-0.99,25.549-2.247c2.804-0.418,5.416,1.519,5.834,4.323 c0.219,1.481-0.216,2.91-1.092,3.991C1292.794,897.491,1291.663,898.176,1290.343,898.373z M1236.681,899.828 c-8.917-0.84-17.86-2.236-26.575-4.145c-2.772-0.609-4.523-3.345-3.917-6.115c0.605-2.769,3.347-4.519,6.112-3.916 c8.312,1.824,16.839,3.154,25.34,3.95c2.824,0.266,4.898,2.771,4.63,5.594c-0.095,1.049-0.503,1.99-1.119,2.749 C1240.107,899.232,1238.458,899.993,1236.681,899.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1477.471,701.191c0.624-0.769,1.031-1.726,1.124-2.787c0.38-4.378,0.631-8.786,0.75-13.105 c0.076-2.833-2.158-5.196-4.993-5.275c-2.829-0.069-5.191,2.159-5.274,4.993c-0.111,4.118-0.353,8.324-0.713,12.502 c-0.245,2.825,1.849,5.314,4.672,5.557C1474.801,703.227,1476.434,702.471,1477.471,701.191z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1415.537,625.579c-0.227-1.086-1.116-1.909-2.216-2.049l-31.386-4.008 c-6.229-13.399-14.639-25.901-25.119-36.919l7.77-30.651c0.272-1.075-0.167-2.204-1.095-2.813l-31.739-20.809 c-0.927-0.609-2.139-0.561-3.016,0.117l-25.011,19.348c-14.283-5.218-29.102-7.946-43.874-8.315l-16.19-27.185 c-0.568-0.953-1.677-1.441-2.763-1.215l-37.157,7.728c-1.086,0.226-1.909,1.116-2.049,2.216l-4.007,31.385 c-13.4,6.229-25.902,14.639-36.92,25.12l-30.651-7.77c-1.075-0.272-2.205,0.167-2.813,1.094l-20.81,31.74 c-0.608,0.928-0.56,2.139,0.118,3.016l19.347,25.011c-5.218,14.283-7.946,29.102-8.314,43.874l-27.186,16.189 c-0.953,0.567-1.441,1.677-1.215,2.763l7.729,37.158c0.226,1.085,1.116,1.908,2.215,2.049l31.387,4.008 c6.228,13.399,14.638,25.902,25.119,36.92l-7.77,30.651c-0.273,1.075,0.167,2.204,1.094,2.813l31.74,20.81 c0.927,0.608,2.138,0.561,3.016-0.118l25.01-19.347c14.283,5.218,29.103,7.946,43.874,8.315l16.189,27.185 c0.567,0.953,1.677,1.441,2.763,1.215l37.157-7.728c1.086-0.226,1.909-1.116,2.05-2.216l4.007-31.386 c13.4-6.228,25.902-14.639,36.92-25.119l30.651,7.77c1.075,0.272,2.204-0.167,2.813-1.095l20.809-31.739 c0.608-0.927,0.561-2.139-0.118-3.016l-19.347-25.011c5.218-14.283,7.945-29.103,8.314-43.874l27.185-16.19 c0.953-0.567,1.441-1.677,1.215-2.763L1415.537,625.579z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1282.533,706.683c-7.638,7.023-17.553,10.648-27.918,10.208 c-10.361-0.436-19.935-4.883-26.954-12.523c-14.488-15.765-13.445-40.337,2.317-54.873 c15.772-14.486,40.385-13.445,54.868,2.319c7.02,7.637,10.646,17.551,10.208,27.915c-0.356,8.424-3.363,16.327-8.579,22.76 C1285.277,703.967,1283.959,705.37,1282.533,706.683z M1235.219,697.419c5.164,5.62,12.206,8.892,19.832,9.215 c7.621,0.321,14.915-2.346,20.533-7.508l0,0c5.612-5.17,8.889-12.205,9.211-19.831c0.325-7.621-2.346-14.915-7.507-20.531 c-10.658-11.597-28.762-12.363-40.362-1.708c-1.046,0.963-2.003,1.984-2.873,3.057 C1225.283,670.929,1225.525,686.87,1235.219,697.419z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1330.532,739.159c2.046-2.524,3.979-5.171,5.8-7.942c3.611-5.505,6.667-11.383,9.085-17.487 c0.107-0.275,0.213-0.55,0.32-0.825c0.822-2.128,0.13-4.467-1.551-5.833c-0.409-0.331-0.878-0.605-1.394-0.804 c-2.645-1.021-5.607,0.308-6.634,2.944c-2.204,5.72-5.036,11.227-8.412,16.371l-0.002,0.002 c-0.184,0.283-0.374,0.564-0.561,0.843c-8.101,12.101-18.912,21.725-31.478,28.309c-6.822,3.573-14.167,6.248-21.885,7.926 c-0.063,0.014-0.125,0.027-0.188,0.041c-0.194,0.04-0.384,0.083-0.576,0.121c-22.607,4.7-45.692,0.319-65.001-12.342 c-2.5-1.637-4.896-3.388-7.185-5.245c-15.405-12.493-25.956-29.762-30.052-49.445c-4.7-22.607-0.315-45.689,12.344-64.997 c12.659-19.292,32.083-32.533,54.688-37.239c22.606-4.7,45.692-0.319,65.001,12.342c2.458,1.609,4.824,3.341,7.091,5.178 c9.828,7.972,17.8,18.001,23.312,29.402c0.34,0.702,0.817,1.292,1.387,1.751c1.496,1.213,3.62,1.531,5.469,0.635 c2.549-1.241,3.623-4.302,2.386-6.86c-6.168-12.756-15.089-23.981-26.079-32.898c-2.539-2.059-5.185-3.994-7.933-5.796 c-21.607-14.165-47.433-19.068-72.727-13.807c-25.289,5.262-47.026,20.034-61.182,41.658 c-14.166,21.603-19.07,47.427-13.806,72.722c4.577,22.019,16.384,41.338,33.619,55.315c2.559,2.074,5.241,4.036,8.035,5.868 C1244.252,786.489,1299.687,777.203,1330.532,739.159z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137815264466453907870000001549537890348635318_",
    gradientUnits: "userSpaceOnUse",
    x1: 14746.0068,
    y1: 3046.3032,
    x2: 14216.4102,
    y2: 3622.3569,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -13735.6787 -63.4747)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137815264466453907870000001549537890348635318_)"
    },
    d: "M813.574,3164.231 c0,0-5.781,30.999-8.763,61.71c-1.166,12.002,7.995,22.52,20.039,23.138c40.916,2.094,128.44,6.246,159.872,5.143 c4.725-0.166,7.859-4.971,6.153-9.381c-1.43-3.695-4.226-6.698-7.811-8.387l-143.992-67.85L813.574,3164.231z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113310577134659974650000012100709734681646013_",
    gradientUnits: "userSpaceOnUse",
    x1: 14574.1084,
    y1: 3089.0823,
    x2: 14621.1494,
    y2: 3089.0823,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -13735.6787 -63.4747)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113310577134659974650000012100709734681646013_)"
    },
    d: "M809.255,3145.944l4.052,37.182 c0,0,25.222,12.036,42.651-1.079l-10.096-41.49L809.255,3145.944z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003095586439128837030000017400130312164878480_",
    gradientUnits: "userSpaceOnUse",
    x1: 14787.7363,
    y1: 2394.8047,
    x2: 14337.0693,
    y2: 3005.6257,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -13735.6787 -63.4747)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003095586439128837030000017400130312164878480_)"
    },
    d: "M819.228,2447.718 c-1.995,9.681-14.834,483.909,33.837,696.947c0.794,3.476-0.998,7.034-4.311,8.352c-7.807,3.103-23.095,7.558-41.371,7.997 c-5.659,0.136-10.697-3.589-12.242-9.035c-14.022-49.454-81.11-297.202-87.917-533.322c-7.607-263.842,0.086-8.98,0.086-8.98 l7.492-162.974L819.228,2447.718z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012436873565405502000000017844706698799142841_",
    gradientUnits: "userSpaceOnUse",
    x1: 14627.2012,
    y1: 2937.0591,
    x2: 14097.582,
    y2: 3513.1367,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -13735.6787 -63.4747)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012436873565405502000000017844706698799142841_)"
    },
    d: "M647.051,3178.843 c0,0-8.881,15.592-17.73,57.165c-1.598,7.508,3.589,14.757,11.221,15.582c13.504,1.458,34.294,3.365,50.963,3.41 c7.683,0.02,13.743-6.613,12.891-14.249c-1.701-15.221-7.215-40.222-24.797-59.833L647.051,3178.843z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126301114168492558670000002197597373722859403_",
    gradientUnits: "userSpaceOnUse",
    x1: 14404.5654,
    y1: 3086.6631,
    x2: 14445.1807,
    y2: 3086.6631,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -13735.6787 -63.4747)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126301114168492558670000002197597373722859403_)"
    },
    d: "M639.839,3130.998l9.76,56.265 c0,0,10.109,7.67,30.301,2.372l-4.339-60.478L639.839,3130.998z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104702601226869605140000013287656156344328108_",
    gradientUnits: "userSpaceOnUse",
    x1: 14707.415,
    y1: 2335.5447,
    x2: 14256.7529,
    y2: 2946.3589,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -13735.6787 -63.4747)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104702601226869605140000013287656156344328108_)"
    },
    d: "M618.417,2460.359 c-43.853,249.854,3.094,618.597,19.425,690.837c1,4.423,4.529,7.838,8.995,8.622c7.584,1.331,20.081,2.479,32.445-0.986 c4.26-1.192,7.281-4.996,7.496-9.415c2.839-58.251,2.143-416.027,42.128-557.039c2.026-7.146,6.461-13.353,12.556-17.599 l75.499-52.596l6.572-86.12L618.417,2460.359z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005953723260432633650000006826566312702405776_",
    gradientUnits: "userSpaceOnUse",
    x1: 12193.8271,
    y1: -8273.2627,
    x2: 11713.877,
    y2: -7918.3696,
    gradientTransform: "matrix(-1 0 0 1 -1192.0675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005953723260432633650000006826566312702405776_)"
    },
    d: "M887.162,1988.706 c-124.245-3.239-261.688,30.135-261.688,30.135c-39.103,215.778-10.917,465.363-10.917,465.363 c95.962,26.146,204.872-13.472,204.872-13.472c16.852-90.185,93.881-343.715,93.881-343.715 c60.787-6.956,110.971-23.996,152.38-46.762c-31.07-36.719-45.44-83.2-51.611-110.654 C970.012,1982.836,925.484,1989.705,887.162,1988.706z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181061721283650704600000013864618775673367693_",
    gradientUnits: "userSpaceOnUse",
    x1: 14767.7383,
    y1: 1861.7941,
    x2: 15008.0801,
    y2: 1861.7941,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -13735.6787 -63.4747)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181061721283650704600000013864618775673367693_)"
    },
    d: "M1255.966,1809.172 c-12.066-14.861-27.583-8.033-27.583-8.033c-19.024,77.07-115.505,138.787-214.304,168.462 c6.171,27.454,20.541,73.936,51.611,110.654C1230.049,1989.895,1255.966,1809.172,1255.966,1809.172z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019658651574421178370000003703492536600691388_",
    gradientUnits: "userSpaceOnUse",
    x1: -4507.8081,
    y1: 1820.5804,
    x2: -4346.5366,
    y2: 2187.5093,
    gradientTransform: "matrix(-1 -0.0095 -0.0095 1 -3288.9529 36.7017)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019658651574421178370000003703492536600691388_)"
    },
    d: "M1252.967,1812.893 c1.239,4.073-13.612,10.115-22.163-6.575c-0.228-7.963-4.744-42.107,0.075-48.547c25.66-34.292,75.184-77.115,75.184-77.115 c8.222,8.27,1.308,16.25,1.308,16.25l-24.062,24.592c4.898,9.052,10.904,16.712,13.649,27.631 c2.078,8.269,0.675,17.072-3.563,24.539c-4.254,7.494-10.053,17.234-15.52,24.847 C1267.526,1812.923,1252.967,1812.893,1252.967,1812.893z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008147648357889095460000008433517427389538177_",
    gradientUnits: "userSpaceOnUse",
    x1: 15006.9277,
    y1: 1699.3125,
    x2: 15074.2207,
    y2: 1595.8494,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -13735.6787 -63.4747)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008147648357889095460000008433517427389538177_)"
    },
    d: "M1272.735,1737.501l-21.886,18.198 l-6.991,18.259l19.152,21.659c0,0,6.855-36.296,11.768-44.12C1279.69,1743.674,1277.218,1739.845,1272.735,1737.501z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047055023325959574700000007020506095536224938_",
    gradientUnits: "userSpaceOnUse",
    x1: 12227.7529,
    y1: -8227.3877,
    x2: 11747.8037,
    y2: -7872.4946,
    gradientTransform: "matrix(-1 0 0 1 -1192.0675 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047055023325959574700000007020506095536224938_)"
    },
    d: "M671.988,2139.621l-46.514-120.78 c0,0-116.824,77.757-136.866,177.567c21.916,1.824,61.77,7.91,100.645,28.007 C598.287,2177.282,671.988,2139.621,671.988,2139.621z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084509363734068194710000011918566307378258075_",
    gradientUnits: "userSpaceOnUse",
    x1: 14241.8232,
    y1: 2202.1987,
    x2: 14545.9678,
    y2: 2202.1987,
    gradientTransform: "matrix(1 0.0095 -0.0095 1 -13735.6787 -63.4747)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084509363734068194710000011918566307378258075_)"
    },
    d: "M772.341,2253.811 c0,0-131.021,72.406-174.392,9.098c-9.004-13.146-11.064-26.144-8.696-38.495c-38.875-20.097-78.728-26.182-100.645-28.007 c-6.042,30.09-3.306,62.179,14.098,94.751c75.679,141.632,286.575-5.053,286.575-5.053L772.341,2253.811z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103945750472745349730000002899854182428162230_",
    gradientUnits: "userSpaceOnUse",
    x1: 708.8276,
    y1: 2106.0728,
    x2: 823.7451,
    y2: 1882.9974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103945750472745349730000002899854182428162230_)"
    },
    d: "M762.255,1886.621l-40.63,113.968 c-0.673,1.887,0.085,3.993,1.831,4.98c10.721,6.061,49.387,23.656,96.465-5.566c4.905-3.044,8.271-8.053,9.066-13.771 l13.748-98.844L762.255,1886.621z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083779894423031292210000005024424977354248119_",
    gradientUnits: "userSpaceOnUse",
    x1: 5352.3086,
    y1: 8268.3379,
    x2: 5307.3711,
    y2: 8120.1245,
    gradientTransform: "matrix(0.7523 -0.6588 0.6588 0.7523 -8602.2764 -818.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083779894423031292210000005024424977354248119_)"
    },
    d: "M849.296,1781.556 c0,0,42.639,82.144,36.759,115.106c-5.88,32.961-59.668,30.077-106.401,2.816l-31.993-88.563L849.296,1781.556z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011725255297452494070000015696525797216850838_",
    gradientUnits: "userSpaceOnUse",
    x1: 5311.769,
    y1: 8010.0981,
    x2: 5349.3584,
    y2: 8224.4951,
    gradientTransform: "matrix(0.7523 -0.6588 0.6588 0.7523 -8602.2764 -818.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011725255297452494070000015696525797216850838_)"
    },
    d: "M782.144,1856.158 c1.918-0.828,2.644-3.159,1.518-4.917c-3.429-5.347-9.845-16.251-11.836-25.762c0,0-7.757-5.073,19.977-11.432 c27.735-6.359,69.098-16.246,77.996-39.716c8.675-22.884-12.992-80.846-48.88-35.17c-1.365,1.738-4.007,1.752-5.338-0.014 c-5.738-7.619-20.867-23.464-42.169-14.149c-19.934,8.717-22.309,23.241-22.106,30.575c0.06,2.157-1.885,3.816-4.001,3.391 c-10.017-2.01-34.085-3.884-45.562,20.715c-9.453,20.26-3.544,31.838,1.882,37.523c1.758,1.842,0.951,4.841-1.491,5.562 c-6.615,1.957-15.185,7.468-14.48,22.929c0.975,21.374,24.878,19.72,31.687,18.81c1.116-0.148,2.235,0.245,2.981,1.087 c5.769,6.508,31.778,34.156,60.18,37.73c2.459,0.31,4.391-2.103,3.607-4.455l-11.964-35.886 c-0.556-1.667,0.257-3.481,1.869-4.178L782.144,1856.158z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028311332049300419930000006274173847120255932_",
    gradientUnits: "userSpaceOnUse",
    x1: 5306.3726,
    y1: 8267.6455,
    x2: 5265.9419,
    y2: 8134.2959,
    gradientTransform: "matrix(0.7523 -0.6588 0.6588 0.7523 -8602.2764 -818.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028311332049300419930000006274173847120255932_)"
    },
    d: "M787.042,1861.282 c0,0-30.712-21.505-33.141-3.665c-2.428,17.84,27.591,26.137,42.563,19.62L787.042,1861.282z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052089461182329886710000013820039928437919414_",
    gradientUnits: "userSpaceOnUse",
    x1: 14338.3135,
    y1: 2080.7671,
    x2: 14506.1396,
    y2: 2780.0459,
    gradientTransform: "matrix(1 0 0 1 -13467.3896 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052089461182329886710000013820039928437919414_)"
    },
    d: "M745.565,2368.24l71.372-249.248 c0.81-2.829,3.224-4.893,6.147-5.234c12.931-1.509,50.402-5.745,93.665-9.404c52.112-4.408,112.63-7.979,148.793-4.941 c5.141,0.432,8.248,5.87,5.962,10.495c-20.564,41.605-105.154,210.844-147.515,266.285c-1.404,1.837-3.574,2.911-5.885,2.889 l-165.596-1.541C747.689,2377.496,744.238,2372.873,745.565,2368.24z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088109475317791161600000004374540380132557994_",
    gradientUnits: "userSpaceOnUse",
    x1: 14223.3135,
    y1: 2265.7634,
    x2: 14318.4004,
    y2: 2265.7634,
    gradientTransform: "matrix(1 0 0 1 -13467.3896 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088109475317791161600000004374540380132557994_)"
    },
    d: "M762.809,2308.022 c0,0-9.943-40.882-5.932-55.386c4.011-14.505,11.781-33.153,37.681-29.009c25.901,4.144,56.453,15.055,56.453,15.055 s-1.543,18.892-21.228,12.797l12.207,9.445c0,0-1.745,15.126-18.372,7.045l11.353,12.526c0,0-7.141,12.424-19.374,4.456 C803.364,2276.982,797.5,2312.945,762.809,2308.022z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M911.991,2178.76c0,11.571,9.38,20.951,20.951,20.951c11.571,0,20.951-9.38,20.951-20.951 c0-11.572-9.38-20.951-20.951-20.951C921.371,2157.809,911.991,2167.188,911.991,2178.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M825.013,2192.571l14.531-49.295c1.783-6.053,6.65-10.598,12.7-11.863 c45.546-9.502,170.207-11.518,171.46-11.536l-0.083-5.569c-5.142,0.079-126.451,2.045-172.515,11.656 c-8.061,1.681-14.539,7.712-16.907,15.736l-14.531,49.295L825.013,2192.571z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072980198294856242750000008045490560417230477_",
    gradientUnits: "userSpaceOnUse",
    x1: 5444.9082,
    y1: 1692.7965,
    x2: 5140.7891,
    y2: 2066.668,
    gradientTransform: "matrix(-0.9922 -0.1247 -0.1247 0.9922 8264.5254 715.4178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072980198294856242750000008045490560417230477_)"
    },
    d: "M2679.973,1821.894 c1.98-3.785,7.582-3.189,8.724,0.927c4.233,15.235,14.478,41.82,35.973,51.26c1.083,0.476,2.108,0.956,3.099,1.44 c0.975-2.923,0.989-6.317-1.346-9.887c-6.683-10.213,5.381-24.161,5.381-24.161s0.799,12.285,10.137,20.02 c8.044,6.664,11.905,21.49,6.409,33.654c-11.634,45.19-29.056,104.957,38.806,148.621 c67.86,43.664,163.428-82.404,163.428-82.404l-47.432,150.368c0,0-73.212,54.026-158.371-21.943 c-85.159-75.97-28.714-186.517-28.714-186.517S2651.115,1877.069,2679.973,1821.894z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137090404290794171150000005726481436109700532_",
    gradientUnits: "userSpaceOnUse",
    x1: -5076.7422,
    y1: 2394.4644,
    x2: -5276.1675,
    y2: 2631.429,
    gradientTransform: "matrix(0.9602 0.2794 -0.2794 0.9602 8902.9297 797.6744)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137090404290794171150000005726481436109700532_)"
    },
    d: "M2962.469,1740.428 c0,0-19.66-88.189,81.359-64.844c0,0,49.036-8.013,51.529,38.269c0,0,31.609,20.828,8.466,60.882 c0,0,93.937-36.284,134.866,46.054c40.928,82.337,3.306,127.642-36.132,139.443c0,0,31.953,16.044,16.828,52.27 c-15.124,36.225-91.72,61.762-136.967,17.707c0,0-128.748,17.014-126.171-73.926c0,0-59.882-38.67,3.014-113.825 C3022.156,1767.303,2962.469,1740.428,2962.469,1740.428z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162329221817858481130000002729298768919247015_",
    gradientUnits: "userSpaceOnUse",
    x1: 3286.9802,
    y1: 1707.2361,
    x2: 3101.0842,
    y2: 1994.5306
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162329221817858481130000002729298768919247015_)"
    },
    d: "M2956.922,1944.844 c20.299-6.085,79.405-17.321,135.624,34.56c9.535,8.8,13.431,22.169,10.031,34.69c-15.101,55.592-54.941,219.835-20.008,290.9 c0,0-61.561,67.862-128.721,13.166c0,0-30.133-131.33-69.6-188.984c-27.249-39.802,43.449-149.469,61.337-175.963 C2948.294,1949.203,2952.286,1946.235,2956.922,1944.844z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176735463717621403280000003648684407984264345_",
    gradientUnits: "userSpaceOnUse",
    x1: -5365.522,
    y1: 2812.25,
    x2: -5349.2744,
    y2: 2696.8923,
    gradientTransform: "matrix(0.9602 0.2794 -0.2794 0.9602 8902.9297 797.6744)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176735463717621403280000003648684407984264345_)"
    },
    d: "M3012.97,1834.398 c0,0,30.021,84.918,32.28,122.381c0,0-33.18,15.087-64.445-10.378c0,0-3.281-84.818-8.021-100.006L3012.97,1834.398z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013180291015436513410000005004255061211148162_",
    gradientUnits: "userSpaceOnUse",
    x1: -5440.0103,
    y1: 2565.071,
    x2: -5288.0913,
    y2: 2739.7371,
    gradientTransform: "matrix(0.9602 0.2794 -0.2794 0.9602 8902.9297 797.6744)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013180291015436513410000005004255061211148162_)"
    },
    d: "M2971.27,1718.615 c0,0-78.523,109.888-31.584,141.807c46.938,31.919,102.836-46.174,102.836-46.174s18.22-60.146-0.832-80.55 C3022.639,1713.294,2971.27,1718.615,2971.27,1718.615z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038387065381340928170000007092348169552584066_",
    gradientUnits: "userSpaceOnUse",
    x1: -5172.2563,
    y1: 2314.083,
    x2: -5371.6865,
    y2: 2551.053,
    gradientTransform: "matrix(0.9602 0.2794 -0.2794 0.9602 8902.9297 797.6744)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038387065381340928170000007092348169552584066_)"
    },
    d: "M3007.615,1692.355 c0,0-36.073,8.547-41.128,24.869c-5.055,16.322,51.155,31.457,66.905,32.197l12.69,65.863c0,0,37.516-61.958,22.655-97.741 C3053.877,1681.759,3007.615,1692.355,3007.615,1692.355z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142871294486385893130000018310686163689571252_",
    gradientUnits: "userSpaceOnUse",
    x1: -5402.0542,
    y1: 2532.0557,
    x2: -5250.1377,
    y2: 2706.7188,
    gradientTransform: "matrix(0.9602 0.2794 -0.2794 0.9602 8902.9297 797.6744)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142871294486385893130000018310686163689571252_)"
    },
    d: "M3027.3,1806.162 c0,0,30.563-35.396,42.72-12.321c12.158,23.075-27.51,40.401-41.242,29.071L3027.3,1806.162z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075863858043540955270000010110024852180099464_",
    gradientUnits: "userSpaceOnUse",
    x1: 4743.356,
    y1: 3309.8564,
    x2: 5105.8003,
    y2: 2670.0637,
    gradientTransform: "matrix(-1 -0.0095 -0.0095 1 8008.4194 56.9446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075863858043540955270000010110024852180099464_)"
    },
    d: "M2875.448,2593.902 c0.23,5.962-10.237,53.253-15.934,78.478c-2.293,10.149-0.696,20.771,4.472,29.802l197.295,332.057 c2.387,4.017,4.124,8.367,5.18,12.919c3.615,15.582,11.115,53.771,7.199,88.514l-10.206,21.198l44.142-10.022l9.603-118.541 l-12.497-7.62c-10.795-6.582-19.201-16.423-24.014-28.115c-17.84-43.334-62.142-153.644-73.562-207.403 c-12.978-61.096-80.824-110.721-80.824-110.721l11.919-28.18L2875.448,2593.902z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124846922278895746530000006654832325896268676_",
    gradientUnits: "userSpaceOnUse",
    x1: 4822.3662,
    y1: 3083.6531,
    x2: 4928.3101,
    y2: 3083.6531,
    gradientTransform: "matrix(-1 -0.0095 -0.0095 1 8008.4194 56.9446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124846922278895746530000006654832325896268676_)"
    },
    d: "M3156.651,3106.058 c0,0-23.837-37.792-26.642-52.503c-2.804-14.71-10.612-40.688-25.308-32.867c0,0-6.925,71.46-4.538,99.383 c2.387,27.922-31.565,27.024-31.565,27.024s-9.358,1.315-16.211,8.166c-4.732,4.731-1.348,12.939,5.329,13.369 c11.111,0.716,28.759,0.903,47.29-2.677c6.476-1.251,11.277-6.762,11.669-13.347l4.892-82.244l30.068,37.967L3156.651,3106.058z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176008604680245601170000015778944447996713875_",
    gradientUnits: "userSpaceOnUse",
    x1: 5154.0947,
    y1: 2836.5537,
    x2: 4612.0439,
    y2: 3009.884,
    gradientTransform: "matrix(-1 -0.0095 -0.0095 1 8008.4194 56.9446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176008604680245601170000015778944447996713875_)"
    },
    d: "M2993.309,2646.795 c0,0,6.958,297.023,7.9,339.207c0.943,42.186-6.661,135.671-48.95,163.615l18.401,13.623c0,0,22.997-19.546,45.465-57.162 c25.238-42.259,32.87-49.979,32.87-49.979l-8.375-17.151c-3.667-7.509-4.744-16.003-3.056-24.187 c9.125-44.231,39.612-191.347,47.929-223.029c9.817-37.399,10.514-87.341-23.638-129.146 C3027.704,2620.781,2993.309,2646.795,2993.309,2646.795z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083804805118427794230000005433289854144276118_",
    gradientUnits: "userSpaceOnUse",
    x1: 4920.5898,
    y1: 3102.7869,
    x2: 5046.8848,
    y2: 3102.7869,
    gradientTransform: "matrix(-1 -0.0095 -0.0095 1 8008.4194 56.9446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083804805118427794230000005433289854144276118_)"
    },
    d: "M3032.36,3176.627 c1.312,0.012,2.427-0.927,2.612-2.226c1.408-9.902,7.266-49.601,12.06-59.881c5.492-11.772,23.43-61.322-0.01-65.53 c0,0-58.273,85.138-69.459,96.617c-11.186,11.479-25.304,4.01-25.304,4.01s-10.899,3.22-19.118,13.723 c-3.912,4.999-0.268,12.337,6.08,12.398l39.25,0.375c11.399,0.109,21.652-6.816,25.889-17.399 c6.91-17.257,18.778-42.57,32.61-53.799l-7.188,68.824C3029.623,3175.273,3030.817,3176.613,3032.36,3176.627L3032.36,3176.627z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107572365259725545280000015262221665003977907_",
    gradientUnits: "userSpaceOnUse",
    x1: 3434.7551,
    y1: 2168.0034,
    x2: 3130.5615,
    y2: 2401.219
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107572365259725545280000015262221665003977907_)"
    },
    d: "M2944.559,2286.137 c0,0,8.845,28.192-4.744,74.627l-84.293,294.357c-1.325,4.626,1.172,9.467,5.7,11.092c25.214,9.049,108.1,34.627,221.247,26.826 c5.696-0.393,10.473-4.426,11.712-10c7.456-33.558,32.892-148.053,38.13-171.579c19.957-89.642,42.24-186.313-55.787-244.766 C3031.346,2286.042,2989.209,2297.448,2944.559,2286.137z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037654063444701155060000017997817816994446737_",
    gradientUnits: "userSpaceOnUse",
    x1: 4824.3096,
    y1: 2232.9512,
    x2: 5425.5625,
    y2: 1545.2068,
    gradientTransform: "matrix(-0.9922 -0.1247 -0.1247 0.9922 8264.5254 715.4178)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037654063444701155060000017997817816994446737_)"
    },
    d: "M3100.59,1990.498 c0,0,95.908,79.703,119.709,188.617c23.801,108.912-140.145,120.488-140.145,120.488s-22.256-24.853-48.68-15.989 c-26.422,8.864-2.046-43.375,28.87-43.238c30.915,0.137,16.593,24.583,60.327,4.772c42.603-19.298,68.935-78.979-39.762-169.449 c-6.301-5.245-11.329-11.93-14.356-19.549C3045.436,2002.993,3062.185,1968.148,3100.59,1990.498z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2466.234,
    y: 2804.242,
    style: {
      fill: "#7D97F4"
    },
    width: 34.209,
    height: 369.957
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2633.152,3181.332h-299.627v-19.796c0-1.366,1.107-2.473,2.473-2.473h294.681 c1.366,0,2.473,1.107,2.473,2.473V3181.332z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2689.814,2790.596c0,21.504-17.594,39.098-39.098,39.098h-322.169 c-21.504,0-39.098-17.594-39.098-39.098v-35.352c0-21.504,17.594-39.098,39.098-39.098h322.169 c21.504,0,39.098,17.594,39.098,39.098V2790.596z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012463777295894072320000015194636590040075943_",
    gradientUnits: "userSpaceOnUse",
    x1: 660.5943,
    y1: 2897.1655,
    x2: 600.2089,
    y2: 3015.9233,
    gradientTransform: "matrix(-0.9764 -0.2161 -0.2161 0.9764 3385.2073 288.5267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012463777295894072320000015194636590040075943_)"
    },
    d: "M2180.085,3061.847 c0,0-110.596,47.635-104.26,97.489c0,0,114.323-21.925,134.782-54.601c20.459-32.676,9.186-51.604,9.186-51.604 L2180.085,3061.847z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092417627136735031990000008612871308892049839_",
    gradientUnits: "userSpaceOnUse",
    x1: 545.7622,
    y1: 2944.4241,
    x2: 605.919,
    y2: 2944.4241,
    gradientTransform: "matrix(-0.9764 -0.2161 -0.2161 0.9764 3385.2073 288.5267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092417627136735031990000008612871308892049839_)"
    },
    d: "M2207.172,3007.403l5.615,48.539 c0.847,7.324-3.221,14.551-10.159,17.05c-3.474,1.251-8.034,2.11-14.013,2.14c-8.437,0.042-15.909-5.504-18.162-13.635 l-10.879-39.259L2207.172,3007.403z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044899017619997900380000017794766155746046911_",
    gradientUnits: "userSpaceOnUse",
    x1: 462.5092,
    y1: 2785.248,
    x2: 718.1486,
    y2: 2426.95,
    gradientTransform: "matrix(-0.9764 -0.2161 -0.2161 0.9764 3385.2073 288.5267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044899017619997900380000017794766155746046911_)"
    },
    d: "M2448.774,2635.186 c0,0-203.419-9.413-304.638,49.615c-101.22,59.028,5.132,342.334,5.132,342.334s26.442,5.683,64.513-14.662 c0,0-54.334-207.393,40.044-243.474c106.105-40.564,215.851-30.696,215.851-30.696l-20.332-96.712L2448.774,2635.186z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012440048447259272930000000728009963011565242_",
    gradientUnits: "userSpaceOnUse",
    x1: 625.5546,
    y1: 3017.2356,
    x2: 416.1996,
    y2: 3291.0071,
    gradientTransform: "matrix(-0.9764 -0.2161 -0.2161 0.9764 3385.2073 288.5267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000012440048447259272930000000728009963011565242_)"
    },
    d: "M2098.052,3137.459 c23.128-5.068,91.72-33.489,102.138-33.107c10.417,0.382,25.177,15.99,25.177,15.99s2.541,8.531-4.908,20.781 c-17.674,13.781-55.743,39.084-100.005,41.854c-32.559,2.039-52.148-10.916-63.354-23.483 C2066.909,3149.947,2082.65,3140.835,2098.052,3137.459z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119830166473047669040000017188870840899204753_",
    gradientUnits: "userSpaceOnUse",
    x1: 520.7844,
    y1: 3076.5288,
    x2: 682.5482,
    y2: 3076.5288,
    gradientTransform: "matrix(-0.9764 -0.2161 -0.2161 0.9764 3385.2073 288.5267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119830166473047669040000017188870840899204753_)"
    },
    d: "M2120.454,3182.978 c44.262-2.771,82.331-28.073,100.005-41.854c-5.036,8.277-14.626,18.25-32.664,28.442 c-44.729,25.271-118.657,21.586-133.312,15.899c-11.744-4.557-8.114-15.525,2.616-25.969 C2068.305,3172.062,2087.895,3185.017,2120.454,3182.978z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175283464213003024550000009609380109782959516_",
    gradientUnits: "userSpaceOnUse",
    x1: 502.2623,
    y1: 2999.9412,
    x2: 558.7227,
    y2: 2999.9412,
    gradientTransform: "matrix(-0.9764 -0.2161 -0.2161 0.9764 3385.2073 288.5267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175283464213003024550000009609380109782959516_)"
    },
    d: "M2249.653,3094.937 c-1.514,5.728-17.716,22.935-27.082,32.527c-4.451,4.559-10.914,6.515-17.138,5.155c-3.948-0.863-8.407-2.21-12.264-4.304 c-5.79-3.144-7.804-10.499-4.629-16.272l23.689-43.08L2249.653,3094.937z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146462367045160269870000007242557726008410250_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.3637,
    y1: 2963.7996,
    x2: 384.4541,
    y2: 2484.7302,
    gradientTransform: "matrix(-0.9764 -0.2161 -0.2161 0.9764 3385.2073 288.5267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146462367045160269870000007242557726008410250_)"
    },
    d: "M2650.367,2618.126 c0,0,17.755,125.965-33.583,151.712c-51.338,25.747-163.944,42.603-202.728,107.935 c-38.783,65.332-108.443,193.566-171.833,230.41c0,0-36.202-11.773-46.783-29.579c0,0,75.243-197.799,106.633-245.877 c27.183-41.635,66.934-101.618,123.407-127.561c16.166-7.427,17.433-24.578,14.587-42.139l-5.183-31.979L2650.367,2618.126z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169523218758761969870000012979861091765941154_",
    gradientUnits: "userSpaceOnUse",
    x1: 2558.5718,
    y1: 2192.7881,
    x2: 2016.1193,
    y2: 2613.5696
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169523218758761969870000012979861091765941154_)"
    },
    d: "M2174.547,2475.334 c71.975,20.546,104.191-182.017,103.902-186.944l110.354,129.027c0,0-65.753,115.701-165.042,128.016 c-25.121,3.115-46.487-1.231-64.411-9.442C2172.555,2514.365,2175.572,2493.004,2174.547,2475.334z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103967181559632505230000003940178756946012331_",
    gradientUnits: "userSpaceOnUse",
    x1: 705.4555,
    y1: 2405.6726,
    x2: 902.4054,
    y2: 2405.6726,
    gradientTransform: "matrix(-0.9764 -0.2161 -0.2161 0.9764 3385.2073 288.5267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103967181559632505230000003940178756946012331_)"
    },
    d: "M2041.258,2409.033 c31.369-12.891,57.98,12.835,57.98,12.835c31.084,31.817,55.737,47.879,75.308,53.466c1.025,17.67-1.991,39.031-15.197,60.657 c-38.781-17.766-61.388-53.683-70.699-71.606c-3.353-6.452-11.213-9.185-17.759-6.019c-6.65,3.215-13.502,8.119-13.931,14.781 c-0.846,13.139-16.481,13.913-16.573,9.061c-0.091-4.853,12.108-30.802,12.108-30.802s-36.044,23.12-50.074,31.964 c-14.03,8.845-25.98-5.751-25.98-5.751S2009.889,2421.925,2041.258,2409.033z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090989291739147490300000013316038563027841183_",
    gradientUnits: "userSpaceOnUse",
    x1: 1934.9321,
    y1: 2777.0154,
    x2: 2452.0354,
    y2: 2457.6282
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090989291739147490300000013316038563027841183_)"
    },
    d: "M2622.64,2205.037 c0,0-96.722-65.985-330.323,53.354c0,0-24.057,30.496-12.788,64.874c11.269,34.379,149.968,220.437,155.357,307.784 c0,0,94.813,55.811,217.892,0.48C2652.777,2631.528,2694.051,2400.889,2622.64,2205.037z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153705619089460319150000001471768644985768341_",
    gradientUnits: "userSpaceOnUse",
    x1: 486.8256,
    y1: 2058.2131,
    x2: 617.4973,
    y2: 2058.2131,
    gradientTransform: "matrix(-0.9764 -0.2161 -0.2161 0.9764 3385.2073 288.5267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153705619089460319150000001471768644985768341_)"
    },
    d: "M2421.231,2120.674l38.224,74.9 c3.795,7.436,3.002,16.437-2.206,22.962c-10.526,13.188-32.499,30.913-69.999,19.489 c-11.155-3.399-19.691-12.474-22.381-23.821l-19.813-83.602L2421.231,2120.674z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021118221492550968960000000311229857214141825_",
    gradientUnits: "userSpaceOnUse",
    x1: 1966.1865,
    y1: 2827.6143,
    x2: 2483.2908,
    y2: 2508.2268
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021118221492550968960000000311229857214141825_)"
    },
    d: "M2694.266,2466.579 c6.546-45.53-113.764-133.775-113.764-133.775l42.138-127.767c0,0,229.58,163.836,181.299,297.632 c-6.922,19.18-17.245,33.154-29.832,43.057C2749.795,2495.866,2716.825,2475.145,2694.266,2466.579z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150065032061990044560000016517881841229204878_",
    gradientUnits: "userSpaceOnUse",
    x1: 781.5383,
    y1: 2553.126,
    x2: 346.6538,
    y2: 3308.8269,
    gradientTransform: "matrix(-0.9952 0.0978 0.0978 0.9952 3094.5051 -105.42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150065032061990044560000016517881841229204878_)"
    },
    d: "M2526.419,2479.213 c0,0,136.096,38.012,164.332-3.416c1.915-2.81,3.039-5.905,3.515-9.218c22.559,8.566,55.529,29.287,79.841,79.147 c-64.617,50.834-189.207-6.15-223.06-23.231c-5.569-2.81-11.972-3.358-17.927-1.501c-12.04,3.757-32.904,9.591-44.528,8.953 c-17.006-0.934-35.26,60.523-64.203,44.965C2424.388,2574.912,2437.543,2469.912,2526.419,2479.213z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044171258208619664040000010821550532829816763_",
    gradientUnits: "userSpaceOnUse",
    x1: 680.5164,
    y1: -52.6605,
    x2: 495.1288,
    y2: 192.5921,
    gradientTransform: "matrix(-0.6545 -0.7561 -0.7561 0.6545 2800.0559 2578.439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044171258208619664040000010821550532829816763_)"
    },
    d: "M2372.238,1998.27 c-1.213,1.05-51.633,89.108-77.296,133.998c-7.835,13.705-1.968,31.153,12.542,37.372l11.117,4.765 c15.193,6.511,47.862,11.965,60.721,1.579l81.053-85.556C2460.375,2090.426,2399.501,1974.672,2372.238,1998.27z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071531039650086121070000000442476262668228020_",
    gradientUnits: "userSpaceOnUse",
    x1: 561.8113,
    y1: -67.1436,
    x2: 756.9477,
    y2: -67.1436,
    gradientTransform: "matrix(-0.6545 -0.7561 -0.7561 0.6545 2800.0559 2578.439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071531039650086121070000000442476262668228020_)"
    },
    d: "M2483.212,2067.085 c9.939-5.585,21.891-16.895,12.586-36.896c-9.458-20.33-28.149-22.095-40.189-20.798c-4.869,0.523-9.272-2.57-10.688-7.258 c-0.805-2.669-2.78-5.026-7.048-5.701c-5.752-0.911-9.324-6.783-7.823-12.41c2.883-10.809,2.392-25.49-14.993-36.015 c-30.849-18.678-59.687,8.452-67.717,32.035c-8.03,23.583,26.567,41.934,48.656,45.676 c16.794,2.847,24.99,22.22,27.955,31.345c0.938,2.889,0.49,6.036-1.18,8.575l-24.644,37.444 c6.778,8.527,12.785,17.537,18.704,26.653c2.216-2.388,4.155-4.375,5.67-5.765c10.703-9.806,29.736-4.745,37.576-2.049 c2.57,0.884,5.365,0.677,7.779-0.572c8.535-4.411,25.767-16.803,11.644-40.237 C2476.544,2076.207,2478.22,2069.89,2483.212,2067.085z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019647472800758714910000001072009759719285161_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.3169,
    y1: 115.8499,
    x2: 578.3444,
    y2: -18.5808,
    gradientTransform: "matrix(-0.6545 -0.7561 -0.7561 0.6545 2800.0559 2578.439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019647472800758714910000001072009759719285161_)"
    },
    d: "M2407.861,2145.74 c0,0,15.755-40.493,33.663-38.235c17.909,2.259,31.305,20.752,8.192,39.949 C2420.967,2171.331,2407.861,2145.74,2407.861,2145.74z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044881811767840518000000002257908953474645426_",
    gradientUnits: "userSpaceOnUse",
    x1: 12793.8164,
    y1: 3172.2419,
    x2: 12537.6426,
    y2: 3242.4521,
    gradientTransform: "matrix(0.9988 -0.0494 0.0494 0.9988 -10528.5889 -55.0328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044881811767840518000000002257908953474645426_)"
    },
    d: "M2352.639,2565.867 c-0.243,0.012-0.486,0.018-0.731,0.017l-317.949-0.347c-7.859-0.007-14.224-6.385-14.216-14.245 c0.008-7.863,6.409-14.358,14.248-14.216l317.949,0.347c7.86,0.006,14.224,6.385,14.216,14.245 C2366.147,2559.281,2360.159,2565.495,2352.639,2565.867z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049911725346471555550000006945898437410284167_",
    gradientUnits: "userSpaceOnUse",
    x1: 12546.9854,
    y1: 2315.8977,
    x2: 12365.2188,
    y2: 2508.0137,
    gradientTransform: "matrix(1 0 0 1 -10487.1201 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049911725346471555550000006945898437410284167_)"
    },
    d: "M1748.137,2277.188h264.79 c19.534,0,37.313,11.272,45.645,28.94l122.412,259.568h-329.063c-12.588,0-23.898-7.691-28.525-19.398l-94.926-240.192 C1722.986,2292.228,1733.214,2277.188,1748.137,2277.188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1934.684,2410.277c5.738,17.827,1.499,35.141-9.468,38.671 c-10.968,3.53-24.509-8.06-30.247-25.888c-5.738-17.828-1.499-35.141,9.468-38.671 C1915.404,2380.859,1928.946,2392.449,1934.684,2410.277z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1791.065,3247.807c-1.761,0-3.551-0.341-5.273-1.057c-6.778-2.823-9.91-10.431-6.994-16.993 l280.214-630.646c2.914-6.56,10.769-9.589,17.553-6.771c6.778,2.823,9.91,10.432,6.993,16.994l-280.214,630.646 C1801.17,3244.874,1796.243,3247.807,1791.065,3247.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2106.738,3247.807c-5.178,0-10.105-2.931-12.281-7.828l-280.214-630.646 c-2.917-6.562,0.215-14.17,6.994-16.994c6.774-2.823,14.635,0.207,17.553,6.771l280.214,630.646 c2.916,6.562-0.215,14.17-6.994,16.993C2110.291,3247.466,2108.5,3247.807,2106.738,3247.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2658.448,3247.807c-1.761,0-3.551-0.341-5.273-1.057c-6.779-2.823-9.91-10.431-6.994-16.993 l280.214-630.646c2.916-6.56,10.766-9.589,17.553-6.771c6.778,2.823,9.909,10.432,6.993,16.994l-280.214,630.646 C2668.553,3244.874,2663.626,3247.807,2658.448,3247.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2974.119,3247.807c-5.178,0-10.105-2.931-12.28-7.828l-280.214-630.646 c-2.916-6.562,0.215-14.17,6.993-16.994c6.774-2.823,14.635,0.207,17.554,6.771l280.214,630.646 c2.916,6.562-0.215,14.17-6.993,16.993C2977.672,3247.466,2975.88,3247.807,2974.119,3247.807z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3006.986,2579.64c0.715-4.136-0.259-8.414-2.654-11.664c-2.395-3.25-5.961-5.132-9.725-5.132 h-1274.77c-4.949,0-9.556,2.824-12.222,7.492c-2.667,4.668-3.024,10.535-0.948,15.565l13.814,33.472 c3.163,7.666,10.017,12.574,17.559,12.574h1247.82c7.016,0,13.046-5.57,14.378-13.282L3006.986,2579.64z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.bda2ac104d3a1e8b95048ea6347ac3ae.svg";
export { ForwardRef as ReactComponent };